<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center" style="width: 100%;">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card " style="border-color: transparent">
            <img src="{{urlBanner}}" alt="Logo-Norm35" class="centradoIMG ">
        </div>
        <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->
    <!-- CONTENT -->
    <div class="content-card" style="margin-top: 2%; margin-left: 5%; margin-right: 15%;">
        <div>

            <h2>{{ 'WIZARD.OBLIGACIONES.TITLE' | translate}}:</h2>


            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/politica">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT1' | translate}}  </button></ul>
            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/encuesta-16-50" *ngIf="!typeMenu">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT2' | translate}}  </button></ul>
            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/encuesta-50-mas" *ngIf="typeMenu">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT3' | translate}}  </button></ul>
            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/medidas-preventivas&control ">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT4' | translate}}  </button></ul>


            <ul><button style="margin-left: 5%;" mat-icon-button aria-label=" " routerLink="/NOM35/wizard/plan-acciones">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT6' | translate}}  </button></ul>
            <ul><button style="margin-left: 5%;" mat-icon-button aria-label=" " routerLink="/NOM35/wizard/kpis">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT7' | translate}}  </button></ul>

            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/encuesta-eventos-traumáticos">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT8' | translate}}  </button></ul>
            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/exámenes-médicos">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT9' | translate}}  </button></ul>
            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/alteraciones-salud">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT10' | translate}}  </button></ul>
            <ul><button mat-icon-button aria-label=" " routerLink="/NOM35/wizard/registros">{{ 'WIZARD.OBLIGACIONES.CONTENT.CONTENT11' | translate}}  </button></ul>


        </div>

    </div><br><br><br><br>

</div>
<!-- / CENTER -->